import { useState, useEffect } from "react";

export function useTimer(timeInSeconds:number) {
  const [seconds, setSeconds] = useState(timeInSeconds);
  useEffect(() => {
    if (seconds > 0) {
      setTimeout(() => setSeconds(seconds - 1), 1000);
    }
  }, [seconds]);

  return {seconds, setSeconds};
}

export default useTimer;
